import "./MarginQuizResultsComponent.scss";
import {QuestionResult} from "../MarginQuizQuestions";
import {ComponentCallback} from "../../../types/AngularJS";
import {IOnInit} from "angular";
import {AnswerResult, QuizScore} from "../service/models/QuizScore";
import {StringKeyed} from "../../../types/GenericTypes";

export const MarginQuizResults = "tfMarginQuizResults";

export function marginQuizResults() {
    return {
        templateUrl: "app/quiz/margin/results/MarginQuizResultsComponent.html",
        bindings: {
            answers: "<",
            onScoreCalculated: "&",
            onComplete: "&",
            onRetry: "&"
        },
        controllerAs: "ctrl",
        controller: MarginQuizResultsComponentController
    };
}

export class MarginQuizResultsComponentController implements IOnInit {

    public answers: Array<QuestionResult>;
    public onScoreCalculated: ComponentCallback;
    public onComplete: ComponentCallback;
    public onRetry: ComponentCallback;

    public passed = false;
    public correctCount = 0;
    public totalQuestions = 0;
    public score: string;

    public $onInit(): void {
        this.calculateScore();
    }

    private calculateScore() {
        const totalQuestions = this.answers.length;
        const numCorrect = this.answers.filter(res => res.correct).length;
        const percentage = (numCorrect / totalQuestions) * 100;
        this.passed = percentage >= 79.9;

        this.correctCount = numCorrect;
        this.totalQuestions = totalQuestions;
        this.score = percentage.toFixed(0);

        const answers = this.buildAnswerMap(this.answers);

        const result: QuizScore = {
            passed: this.passed,
            score: +this.score,
            answers
        };
        this.onScoreCalculated({score: result});
    }

    private buildAnswerMap(results: Array<QuestionResult>): StringKeyed<AnswerResult> {
        return results.map(res => this.buildAnswerResult(res))
                      .reduce((acc, next) => Object.assign(acc, next), {});
    }

    private buildAnswerResult(result: QuestionResult): StringKeyed<AnswerResult> {
        const name = result.question.name;
        const answer = {
            answer: String(result.answer),
            correct: result.correct
        };
        return {
            [name]: answer
        };
    }
}
